import { CONSTANTS } from '@pk/powerkioskutils';
import moment from 'moment-timezone';
import { ViewEnterpriseDashboardBudgetMonthDetail } from './view-enterprise-dashboard-budget-month-detail';

export class ViewEnterpriseDashboardBudgetMonth {
	public originContractId: string;
	public contractId: string;
	public agentId: string;
	public parentId: string;
	public contractNum: string;
	public originContractNum: string;
	public effectiveDate: Date;
	public expirationDate: Date;
	public confirmationDate: Date;
	public productId: string;
	public productName: string;
	public dbaName: string;
	public supplierId: string;
	public supplierName: string;
	public utilityIdList: string;
	public utilityNameList: string;
	public serviceTypeId: string;
	public serviceTypeName: string;
	public address1: string;
	public address2: string;
	public city: string;
	public stateId: string;
	public stateShort: string;
	public zipCode: string;
	public countryId: number;
	public countryName: string;
	public date: Date;
	public referenceBudgetYearDate: Date;

	public referenceUsage: number;
	public referenceSupplyRate: number;
	public referenceBudgetDeliveryCost: number;
	public referenceBudgetDeliveryAndTaxCost: number;
	public referenceBudgetTaxCost: number;
	public referenceSupplyCost: number;
	public referenceBudgetCost: number;

	public actualUsage: number;
	public actualSupplyRate: number;
	public actualDeliveryCost: number;
	public actualTaxCost: number;
	public actualDeliveryAndTaxCost: number;
	public actualSupplyCost: number;
	public actualCost: number;

	public deliveryVarianceAmount: number;
	public taxVarianceAmount: number;
	public deliveryAndTaxVarianceAmount: number;
	public supplyVarianceAmount: number;
	public usageVarianceAmount: number;
	public deliveryVariancePercent: number;
	public taxVariancePercent: number;
	public deliveryAndTaxVariancePercent: number;
	public supplyVariancePercent: number;
	public usageVariancePercent: number;
	public varianceAmount: number;
	public variancePercent: number;

	public currentBudgetUsage: number;
	public currentBudgetSupplyRate: number;
	public currentBudgetDeliveryCost: number;
	public currentBudgetDeliveryAndTaxCost: number;
	public currentBudgetTaxCost: number;
	public currentBudgetSupplyCost: number;
	public currentBudgetCost: number;

	public details: ViewEnterpriseDashboardBudgetMonthDetail[];

	constructor(viewEnterpriseDashboardBudgetMonth: ViewEnterpriseDashboardBudgetMonth) {
		Object.assign(this, viewEnterpriseDashboardBudgetMonth);

		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY 00:00:00 a')) : this.effectiveDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY 00:00:00 a')) : this.expirationDate;
		this.confirmationDate = this.confirmationDate ? new Date(moment(this.confirmationDate).format('MMM DD, YYYY 00:00:00 a')) : this.confirmationDate;
		this.referenceBudgetYearDate = this.referenceBudgetYearDate ? new Date(moment(this.referenceBudgetYearDate).format('MMM DD, YYYY 00:00:00 a')) : this.referenceBudgetYearDate;
		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY 00:00:00 a')) : this.date;

		this.details = [
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: 'Contracted Volume',
				referenceBudget: this.referenceUsage,
				actual: this.actualUsage,
				varianceAmount: this.usageVarianceAmount,
				variancePercent: this.usageVariancePercent,
				currentBudget: this.currentBudgetUsage,
				currentBudgetPercent: this.usageVariancePercent,
			}),
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: 'Supply Cost',
				referenceBudget: this.referenceSupplyCost,
				actual: this.actualSupplyCost,
				varianceAmount: this.supplyVarianceAmount,
				variancePercent: this.supplyVariancePercent,
				currentBudget: this.currentBudgetSupplyCost,
				currentBudgetPercent: this.supplyVariancePercent,
			}),
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: 'Delivery & Tax',
				referenceBudget: this.referenceBudgetDeliveryAndTaxCost,
				actual: this.actualDeliveryAndTaxCost,
				varianceAmount: this.deliveryAndTaxVarianceAmount,
				variancePercent: this.deliveryAndTaxVariancePercent,
				currentBudget: this.currentBudgetDeliveryAndTaxCost,
				currentBudgetPercent: this.deliveryAndTaxVariancePercent,
			}),
		];

		const blendedSupplierRateLabel = [CONSTANTS.products.fixedAllInElectric, CONSTANTS.products.fixedAllInGas].includes(this.productId)
			? 'Supply Rate'
			: 'Blended Supply Rate';

		this.details.push(
			new ViewEnterpriseDashboardBudgetMonthDetail({
				label: blendedSupplierRateLabel,
				referenceBudget: this.referenceSupplyRate,
				actual: this.actualSupplyRate,
				varianceAmount: ((this.actualSupplyRate !== null && this.actualSupplyRate !== 0 && this.currentBudgetSupplyRate !== null) ? Math.round((this.actualSupplyRate - this.currentBudgetSupplyRate) * 1e12) / 1e12 : null),
				variancePercent: this.actualSupplyRate !== null && this.actualSupplyRate !== 0 && this.currentBudgetSupplyRate !== null ? Math.round(((this.actualSupplyRate - this.currentBudgetSupplyRate) / this.actualSupplyRate) * 1e12) / 1e12 : null,
				currentBudget: this.currentBudgetSupplyRate,
				currentBudgetPercent: this.supplyVariancePercent,
			}),
		);
	}
}
